import { Text } from "@zapier/design-system";
import styles from "./CopilotHeader.module.css";

type CopilotHeaderProps = {
  templateName: string;
  templateImageUrl?: string;
  firstMessageAgo: string;
};

export const CopilotHeader = ({
  templateName,
  templateImageUrl,
  firstMessageAgo,
}: CopilotHeaderProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>
        <div className={styles.headerTop}>
          <div className={styles.clickIcon} />
          <Text type="MinimalPrint2" color="TextWeaker">
            You asked Copilot about
          </Text>
        </div>
        <Text type="ParagraphHeader3">{templateName}</Text>
        <Text type="MinimalPrint2" color="TextWeakest">
          {firstMessageAgo}
        </Text>
      </div>
      {templateImageUrl && (
        <img
          className={styles.mainImage}
          src={templateImageUrl}
          alt={templateName}
        />
      )}
    </div>
  );
};
